import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private router: Router, private http: HttpClient) { }

  // Check if user is authenticated
  isAuthenticated(): boolean {
    const token = localStorage.getItem('jwt_token');
    if (!token) {
      return false;
    }
    return true;
  }


 
 

  createFLXid(email:any): Observable<any> {
    const body = {
      "email": email,
      "three_month_avg_deposit": 50000,
      "nsf_total_last_3_months": 3,
      "avg_daily_balance_last_3_months": 15000,
      "outside_lending_monthly_servicing_month_1": 2500
    }
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
    return this.http.post<any>(`${environment.baseUrl}v1/financelogix/createFLXid`, body, { headers });
  }
 
  updateFLXid(id:string, body:any): Observable<any> {
    // const body = {
    //     "rev_hs_id": "123456899",
    //     "flx_hs_id": "789012399",
    //     "oppId": "006a0123549",
    //     "email": email,
    //     "merchant_info": merchantInfo
    // }
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
    return this.http.put<any>(`${environment.baseUrl}v1/financelogix/updateFLXid/${id}`, body, { headers });
  }

  getFLXidDetails(flxId: string): Observable<any> {
    const headers = new HttpHeaders()
      .set('accept', 'application/json')
    return this.http.get<any>(`${environment.baseUrl}v1/financelogix/getFLXidDetails/${flxId}`, { headers });
  }

  login(email: string, password: string): Observable<any> {
    const body = {
      email: email,
      password: password
    };
    const headers = new HttpHeaders()
      .set('accept', '*/*')
      .set('Content-Type', 'application/json');
      return this.http.post<any>(`${environment.baseUrl}v1/auth/login`, body, { headers });
    // return this.http.post<any>(`${environment.baseUrl}v1/auth/login-2fa`, body, { headers });
  }

  verify2fa(code: string ,mfaToken: string, bindingCode: string): Observable<any> {
    const body = {
      code: code,
      mfa_token: mfaToken,
      binding_code: bindingCode
    };
    const headers = new HttpHeaders()
      .set('accept', '*/*')
      .set('Content-Type', 'application/json');
    return this.http.post<any>(`${environment.baseUrl}v1/auth/verify-2fa`, body, { headers });
  }

  resend2fa(mfaToken: string): Observable<any> {
    const body = {
      mfa_token: mfaToken
    };
  
    return this.http.post<any>(`${environment.baseUrl}v1/auth/resend-2fa`, body);
  }

  forgotPassword(email: string): Observable<any> {
    const body = {
      email: email
    };
    const headers = new HttpHeaders()
      .set('accept', '*/*')
      .set('Content-Type', 'application/json');
    return this.http.post<any>(`${environment.baseUrl}v1/auth/forgot-password`, body, { headers });
  }

  resetPassword(email: string, token: string, password: string): Observable<any> {
    const body = {
      email: email,
      token: token,
      password: password
    };
    return this.http.post<any>(`${environment.baseUrl}v1/auth/reset-password`, body);
  }

  validatePasswordToken(email: string, passwordToken: string): Observable<any> {
    const body = {
      email: email,
      passwordToken: passwordToken
    };
    return this.http.post<any>(`${environment.baseUrl}v1/auth/validate-password-token`, body);
  }
  

  verifyBusiness(data: any): Observable<any> {
    return this.http.post<any>(`https://apply2-uat.revenued.com/api/searchBusiness`, data)

  }

}
